import React from "react";
import PageTemplate from "../../../templates/page-template";

export default function BecomeAnEmployerPage() {
	return <PageTemplate header="Become An Employer" />;
}
